import RestApiModel from "@/api/Model/RestApiModel";
import api from "@/api";

class ClientMap extends RestApiModel {
  static getResourceEndpoint() {
    return '/client-maps';
  }

  /**
   * @param companyId
   * @returns {*}
   */
  static downloadBulkUpdateProducerTemplate(companyId) {
    return api.get(`${this.getResourceEndpoint()}/bulk-update-producer-template/${companyId}/`,  { responseType: 'arraybuffer' });
  }

  /**
   * @param productId
   * @param secondProductId
   * @returns {*}
   */
  static downloadBulkUpdateProductTemplate(productId, secondProductId) {
    return api.get(`${this.getResourceEndpoint()}/bulk-update-product-template/${productId}/${secondProductId}/`,  { responseType: 'arraybuffer' });
  }

  /**
   * @param params
   * @returns {*}
   */
  static uploadTemplate(params) {
    return api.post(`${this.getResourceEndpoint()}/upload-template/`, params);
  }

  static updateMany(clientMaps) {
    return api.post(`${this.getResourceEndpoint()}/update-many/`, {clientMaps});
  }
}

export default ClientMap;
